import React from 'react';
import Markdown from 'react-markdown';

import { MarkdownRoot } from './SimpleMarkdownRenderer.styles';

export interface SimpleMarkdownRendererProps {
  markdown: string;
  /** Supports customization through styled(SimpleMarkdownRenderer). */
  className?: string;
  /** Small preserves compact cards; medium supports longer reading. */
  size?: 'small' | 'medium';
}

/** Lightweight, theme-aware Markdown for read-only content. */
export const SimpleMarkdownRenderer: React.FC<SimpleMarkdownRendererProps> = ({
  markdown,
  className,
  size = 'small',
}) => (
  <MarkdownRoot className={className} size={size}>
    <Markdown
      components={{
        // External references must not navigate away from an unfinished form.
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        ),
      }}
    >
      {markdown}
    </Markdown>
  </MarkdownRoot>
);
